module.exports = __webpack_public_path__ + "img/43_71.80e84ad1.png";